export const COPY_BOARD = 'events/COPY_BOARD';

/**
 * @param board
 * @param charts
 * @return {{type: string, payload: { board, charts, intl, messages }}
 */
export const copyBoard = (board, charts, intl, messages) => ({
  type: COPY_BOARD,
  payload: {
    board, charts, intl, messages, 
  },
});
